'use client'

import React, { useEffect, useState } from 'react';
import Markdown from '@/components/atoms/markdown';
import Typography from '@/components/atoms/typography';

const DisclaimerSection = ({ privacyPolicyData }: any) => {

  const title = privacyPolicyData?.sections?.[0]?.section_with_heading_description?.title ?? '';
  const summary = privacyPolicyData?.sections?.[0]?.section_with_heading_description?.description ?? "";
  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    const handleLoad = () => {
      setPageLoaded(true);
    };

    if (document.readyState === 'complete') {
      // Page already loaded (e.g., fast navigation)
      setPageLoaded(true);
    } else {
      // Wait for full load
      window.addEventListener('load', handleLoad);
    }

    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);
  return (
    <div className={`flex justify-center ${!pageLoaded && "mt-[181px]"}`}>
      <div className="flex flex-col items-center px-[36px] lg:px-[90px] py-[18px]">
        {title && (
          <Typography
            fontSize={24}
            className="pb-3 text-[24px] lg:text-[48px] !font-medium  leading-10 text-gray-700 text-center"
          >
            {title}
          </Typography>
        )}

        <Markdown className='text-primary-black  text-[16px] leading-[23px] pb-[25px] disclaimer-text '>{summary}</Markdown>
      </div>
    </div>
  );
};

export default DisclaimerSection;